import React from 'react';
import { Button, Grid, makeStyles, colors } from '@material-ui/core';

import Routes from 'config/routes';

import Link from 'components/Link';

const useStyles = makeStyles({
  signInButton: {
    color: colors.grey[50],
    backgroundColor: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  signUpButton: {
    color: colors.red[400],
    borderColor: colors.red[100],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const Buttons = ({ justify = 'center' }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={1} justify={justify}>
      <Grid item>
        <Link pathname={Routes.LOGIN}>
          <Button
            className={classes.signInButton}
            variant="contained"
            size="small"
          >
            <b>LOGIN</b>
          </Button>
        </Link>
      </Grid>

      <Grid item>
        <Link pathname={Routes.createAccount()}>
          <Button
            className={classes.signUpButton}
            variant="outlined"
            size="small"
          >
            <b>CREATE ACCOUNT</b>
          </Button>
        </Link>
      </Grid>
    </Grid>
  );
};

export default Buttons;
